import { ref } from 'vue'

export function useVideoThumbnail() {
  const videoThumbnail = ref(null)

  const generateVideoThumbnail = (url) => {
    const video = document.createElement('video')
    video.src = url
    video.crossOrigin = 'anonymous'
    video.muted = true
    video.playsInline = true

    video.addEventListener('loadedmetadata', () => {
      const seekTime = Math.min(1, video.duration / 2 || 1)
      video.currentTime = seekTime
    })

    video.addEventListener('seeked', () => {
      requestAnimationFrame(() => {
        const { videoWidth, videoHeight } = video
        if (!videoWidth || !videoHeight) return

        const canvas = document.createElement('canvas')
        canvas.width = videoWidth
        canvas.height = videoHeight
        const ctx = canvas.getContext('2d')
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
        videoThumbnail.value = canvas.toDataURL('image/jpeg')
      })
    })

    video.addEventListener('error', (err) => {
      console.error('videoThumbnail generation error:', err)
    })

    video.load()
  }

  return { videoThumbnail, generateVideoThumbnail }
}
